module.exports = __webpack_public_path__ + "static/media/JS.b36f1131.png";